<app-header></app-header>

<section class="bredcrumb">
  <div class="container">
      <ul class="brd-nav">
          <li> <a [routerLink]="['/']"> Home </a></li>
          <li> <span> Wallet </span></li>
      </ul>
  </div>
</section>

<section class="single-page order-list padd-row">
  <div class="container">

    <h3>Wallet balance : ₹ {{ balance ? balance : loginData.wallet }}</h3>
    <button class="btn btn-sm btn-style" (click)="showAddMoney()" style="float:right">ADD MONEY </button>

    <div class="doc-detail-nav">
        <ul class="nav nav-pills">
            <li class="nav-item">
                <a class="nav-link active" data-toggle="pill" href="#doc-details-1"> Wallet History </a>
            </li>
            
        </ul>
    </div>
    <div #target class="tab-pane active" id="doc-details-1">
        <div class="doc-detail-right-main">
            <div class="doc-detail-cnt pt-0 pb-0">
             <ul>
               <li *ngFor="let log of walletLogs">
                 <p>MONEY ADDED</p>
                 <!-- <span>ADDED BY {{ log.amount_added_by }}</span> -->
                 <!-- <br> -->
                 <span>{{ log.createdAt |  date:'EE,LLL dd yyyy' }}</span>
                 <p style="float:right">₹{{ log.amount  }}</p>

                <hr class="w-100">
               </li>
             </ul>
            </div>
                   
         
        </div>
    </div>


  </div>
</section>
<input type="hidden" id="amountAddTrigger" data-toggle="modal" data-target="#add-amount-modal">
<div class="modal fade" id="add-amount-modal">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <!-- Modal body -->
            <div class="modal-body">
                <div class="sign-up-form add-doc-form">                         
                    <div class="add-doc-ambu-cmn add-treat-form">
                        <h2>ADD MONEY </h2>
                        <form class="doctors-edit-main p-0 no-shadow">
                            <div class="doctors-edit-lft">
                                <div class="edit-profile-form-rows">
                                    <div class="row no-gutters">
                                        <div class="col-md-12">
                                            <label> Amount </label>
                                            <input type="text" (keypress)="numberOnly($event,null)" name="amount" [(ngModel)]="amount" class="form-control" placeholder="Enter amount">
                                            <div class="alert alert-danger" *ngIf="error">Please Enter amount between 50 & 10000</div>
                                        </div>

                                        <ul class="w-100 ul_wallet mb-3">
                                          <li (click)="setAmount(100)" class="li_wallet mr-4" [class.li_wallet_active]="amount == 100">₹100</li>
                                          <li (click)="setAmount(500)" class="li_wallet mr-4" [class.li_wallet_active]="amount == 500">₹500</li>
                                          <li (click)="setAmount(1000)" class="li_wallet mr-4" [class.li_wallet_active]="amount == 1000">₹1000</li>
                                        </ul>

                                        <p>Note: Minimum amount that could be added is ₹50 and maximum is ₹10000</p>
                                       
                                        
                                        <div class="col-md-12">
                                            <div class="add-doc-btns-btm mt-3">
                                                <!-- <button type="submit"    class="btn-style no-shadow"> Save </button>
                                                <button type="button"  class="btn-style btn-style-grey  no-shadow" data-dismiss="modal"> Cancel </button> -->
                                                <a [routerLink]="null"  (click)="payWithRazor()" class="btn-style no-shadow"> Save </a>
                                                
                                                <a href="javascript://" class="btn-style btn-style-grey  no-shadow" data-dismiss="modal"> Cancel </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>